import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { baseQuery, createQueryString, getToken } from "../utility/helper";

export const expenseApi = createApi({
  reducerPath: "expenses",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getToken();
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ["Expenses"],
  endpoints: (builder) => ({
    createExpense: builder.mutation({
      query: (formData) => ({
        url: "/accountings/expenses",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Expenses"],
    }),

    updateExpense: builder.mutation({
      query: ({ id, formData }) => ({
        url: `/accountings/expenses/${id}`,
        method: "PATCH",
        body: formData,
      }),
      invalidatesTags: ["Expenses"],
    }),

    deleteExpense: builder.mutation({
      query: (id) => ({ url: `/accountings/expenses/${id}`, method: "DELETE" }),
      invalidatesTags: ["Expenses"],
    }),

    getExpenses: builder.query({
      query: ({ page = 1, perPage = 10, status = "", buildingId = null }) => {
        const params = {
          options: {
            query: {
              ...(buildingId && { buildingId }),
              ...(status && { billStatus: status }),
            },
            page,
            limit: perPage,
            populate: [
              {
                dir: "accountings/chartOfAccounts",
                path: "expenseType",
              },
              {
                dir: "vendors",
                path: "vendor",
              },
              {
                dir: "users",
                path: "createdBy",
                select: "_id username",
              },
            ],
          },
        };

        const serializedParams = createQueryString(params);
        return `/accountings/expenses?${serializedParams}`;
      },
      providesTags: ["Expenses"],
    }),

    getExpenseFigures: builder.query({
      query: (buildingId) =>
        `/accountings/expenses/figures?buildingId=${buildingId || ""}`,
      providesTags: ["Expenses"],
    }),

    getExpenseById: builder.query({
      query: (id) => `/accountings/expenses/${id}`,
      providesTags: (result, error, id) => [{ type: "Expenses", id }],
    }),
  }),
});

export const {
  useGetExpensesQuery,
  useCreateExpenseMutation,
  useUpdateExpenseMutation,
  useDeleteExpenseMutation,
  useGetExpenseFiguresQuery,
  useGetExpenseByIdQuery,
} = expenseApi;
